<template>
  <svg 
    class="pulsingring-loader" 
    viewBox="0 0 40 40" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle 
      cx="20" 
      cy="20" 
      fill="none" 
      r="10" 
      :stroke="color" 
      stroke-width="2"
    >
      <animate 
        attributeName="r" 
        from="8" 
        to="20" 
        dur="2.5s" 
        begin="0s" 
        repeatCount="indefinite"
      />
      <animate 
        attributeName="opacity" 
        from="1" 
        to="0" 
        dur="2.5s" 
        begin="0s" 
        repeatCount="indefinite"
      />
    </circle>
    <circle 
      cx="20" 
      cy="20" 
      fill="none" 
      r="10" 
      :stroke="color" 
      stroke-width="2"
    >
      <animate 
        attributeName="r" 
        from="8" 
        to="20" 
        dur="2.5s" 
        begin="-0.8s" 
        repeatCount="indefinite"
      />
      <animate 
        attributeName="opacity" 
        from="1" 
        to="0" 
        dur="2.5s" 
        begin="-0.8s" 
        repeatCount="indefinite"
      />
    </circle>
    <circle 
      cx="20" 
      cy="20" 
      fill="none" 
      r="10" 
      :stroke="color" 
      stroke-width="2"
    >
      <animate 
        attributeName="r" 
        from="8" 
        to="20" 
        dur="2.5s" 
        begin="-1.6s" 
        repeatCount="indefinite"
      />
      <animate 
        attributeName="opacity" 
        from="1" 
        to="0" 
        dur="2.5s" 
        begin="-1.6s" 
        repeatCount="indefinite"
      />
    </circle>
  </svg>
</template>

<script>
export default {
  name: 'PulsingRingLoader',
  props: {
    color: {
      type: String,
      default: '#a855f7' // moone-purple color
    }
  }
}
</script>

<style scoped>
.pulsingring-loader {
  width: 100%;
  height: 100%;
  max-width: 40px;
  max-height: 40px;
}
</style>
